<template>
  <div class="detail-page">
    <div v-if="detailData">
      <div class="detail-content">
        <div class="top" v-show="!isShareing">
          <div class="article-info">
            <div class="title">
              {{ detailData.title || '' }}
            </div>
            <div class="review">
              <span>查看次数：{{ detailData.num | formatDynamicNumber }}</span>
              <span class="line"></span>
              <span>{{ detailData.addtime }}</span>
            </div>
            <div class="info-bottom">
              <span
                class="keyword-title"
                v-if="
                  detailData.keyword1 ||
                  detailData.keyword2 ||
                  detailData.keyword3
                "
                >关键词：</span
              >
              <span class="keyword" v-if="detailData.keyword1">{{
                detailData.keyword1
              }}</span>
              <span class="keyword" v-if="detailData.keyword2">{{
                detailData.keyword2
              }}</span>
              <span class="keyword" v-if="detailData.keyword3">{{
                detailData.keyword3
              }}</span>
              <div class="line"></div>
              <span v-if="detailData.info.way_data">可公开渠道：</span>
              <img
                class="public-image"
                v-for="(item, index) in detailData.info.way_data"
                :key="index"
                :src="item.icon"
              />
            </div>
          </div>
          <div class="user-info">
            <img
              class="avatar"
              @click.stop="jumpUserInfo"
              :src="detailData.info.user_head"
            />
            <div class="user-info-right">
              <div class="">
                <span class="user-name">{{
                  detailData.info.nickname || ''
                }}</span>
                <span
                  class="tag-item"
                  v-for="(item, index) in detailData.info.label_data"
                  :key="index"
                  >{{ item }}</span
                >
              </div>
              <div class="camp">
                {{ detailData.info.product_alias_name || '' }}学员
                {{ detailData.info.coach_name }}
              </div>
            </div>
          </div>
        </div>
        <!-- 菜单 -->
        <div class="compare-canvas" v-show="!isShareing">
          <div class="compare-title">
            <div class="title-content">
              <span class="title-line"></span>
              <span class="title-text">我的蜕变</span>
              <span class="title-line"></span>
            </div>
            <div class="type-list">
              <div
                class="type-item"
                :class="{ 'type-item-active': curType == index }"
                v-for="(item, index) in typeList"
                :key="index"
                @click.stop="changeType(index)"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <div class="echart-content">
            <div class="echart-canvas">
              <van-swipe
                ref="weightWaist"
                class="echart-swiper"
                :autoplay="20000"
                indicator-color="white"
                :loop="false"
                :show-indicators="false"
                @change="changeSwiper"
              >
                <van-swipe-item v-for="(item, index) in typeList" :key="index">
                  <div v-show="canvasData.length">
                    <div class="compare-weight">
                      <div class="change"
                        ><span class="weight-change">{{
                          canvasData[index].changeData
                        }}</span
                        ><span class="weight-unit">{{
                          canvasData[index].unit
                        }}</span></div
                      >
                      <div>
                        <div
                          ><span class="weight-text"
                            >初始{{ canvasData[index].name }}:</span
                          ><span class="weight-num"
                            >{{ canvasData[index].startData
                            }}{{ canvasData[index].unit }}</span
                          ></div
                        >
                        <div
                          ><span class="weight-text"
                            >当前{{ canvasData[index].name }}:</span
                          ><span class="weight-num"
                            >{{ canvasData[index].curData
                            }}{{ canvasData[index].unit }}</span
                          ></div
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="mychart-content"
                    v-show="canvasData[index].xList.length"
                  >
                    <div
                      class="my-chart"
                      :id="'mychart-dom-line-' + index"
                    ></div>
                  </div>
                  <img
                    class="no-img"
                    v-if="!canvasData[index].xList.length"
                    src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e3ac4c595c1a08370e4ac3cc02c92389.png"
                  />
                </van-swipe-item>
              </van-swipe>
            </div>
          </div>
        </div>
        <!-- 对比照 -->
        <div class="compare-container">
          <template
            v-if="
              detailData.info.start_life_img.length ||
              detailData.info.end_life_img.length
            "
          >
            <div class="title" v-show="!isShareing">生活照</div>
            <div class="compare-swiper-content">
              <van-swipe
                class="my-swipe"
                :autoplay="20000"
                indicator-color="white"
                :loop="false"
                :show-indicators="false"
                @change="bindPictureChange"
              >
                <van-swipe-item
                  class="compare-swiper-item"
                  v-for="(item, index) in detailData.info.end_life_img.length >
                  detailData.info.start_life_img.length
                    ? detailData.info.end_life_img
                    : detailData.info.start_life_img"
                  :key="index"
                >
                  <div class="image-content">
                    <div
                      class="image-item"
                      v-if="detailData.info.start_life_img[index]"
                    >
                      <div class="compare-image-content">
                        <img
                          @click.stop="
                            previewLiveImage(
                              detailData.info.start_life_img[index]
                            )
                          "
                          class="compare-image"
                          :src="detailData.info.start_life_img[index]"
                        />
                      </div>
                      <div class="image-text">入营前</div>
                    </div>
                    <div
                      class="image-item"
                      v-if="detailData.info.end_life_img[index]"
                    >
                      <div class="compare-image-content">
                        <img
                          class="compare-image"
                          @click.stop="
                            previewLiveImage(
                              detailData.info.end_life_img[index]
                            )
                          "
                          :src="detailData.info.end_life_img[index]"
                        />
                      </div>
                      <div class="image-text">入营后</div>
                    </div>
                  </div>
                </van-swipe-item>
              </van-swipe>
            </div>
            <div class="swiper-indicator">
              <span
                class="swiper-indicator-item"
                :class="{ 'swiper-indicator-item-active': curSwiper == index }"
                v-for="(item, index) in detailData.info.end_life_img.length >
                detailData.info.start_life_img.length
                  ? detailData.info.end_life_img
                  : detailData.info.start_life_img"
                :key="index"
              ></span>
            </div>
          </template>
          <template
            v-if="
              detailData.info.start_img.length || detailData.info.end_img.length
            "
          >
            <div class="title">对比照</div>
            <div class="compare-swiper-content">
              <van-swipe
                class="compare-swiper"
                :autoplay="20000"
                indicator-color="white"
                :loop="false"
                :show-indicators="false"
                @change="bindPicture1Change"
              >
                <van-swipe-item
                  class="compare-swiper-item"
                  v-for="(item, index) in detailData.info.end_img.length >
                  detailData.info.start_img.length
                    ? detailData.info.end_img
                    : detailData.info.start_img"
                  :key="index"
                >
                  <div class="image-content">
                    <div
                      class="image-item"
                      v-if="detailData.info.start_img[index]"
                    >
                      <div class="compare-image-content">
                        <img
                          class="compare-image"
                          @click.stop="
                            previewCompareImage(
                              detailData.info.start_img[index]
                            )
                          "
                          :src="detailData.info.start_img[index]"
                        />
                      </div>
                      <div class="image-text">入营前</div>
                    </div>
                    <div
                      class="image-item"
                      v-if="detailData.info.end_img[index]"
                    >
                      <div class="compare-image-content">
                        <img
                          class="compare-image"
                          @click.stop="
                            previewCompareImage(detailData.info.end_img[index])
                          "
                          :src="detailData.info.end_img[index]"
                        />
                      </div>
                      <div class="image-text">入营后</div>
                    </div>
                  </div>
                </van-swipe-item>
              </van-swipe>
            </div>
            <div class="swiper-indicator">
              <span
                class="swiper-indicator-item"
                :class="{ 'swiper-indicator-item-active': curSwiper1 == index }"
                v-for="(item, index) in detailData.info.end_img.length >
                detailData.info.start_img.length
                  ? detailData.info.end_img
                  : detailData.info.start_img"
                :key="index"
              ></span>
            </div>
          </template>
        </div>
        <div class="content-item camp-study">
          <div class="title-content">
            <span class="title-line"></span>
            <span class="title-text">我的营期学习</span>
            <span class="title-line"></span>
          </div>
          <div class="user-talk-content">
            <img
              class="dot"
              src="https://cdnvue.gymcity.com.cn/uploads/58e186fb369273119c9e9aa966d63a4c.png"
            />
            <div class="text">
              在减脂营内，营养师会讲解很多营养知识，教会我如何正确的吃
            </div>
            <div class="userinfo">
              <div class="line"></div>
              <img
                class="avatar"
                mode="aspectFill"
                :src="detailData.info.user_head"
              />
              <div class="username">{{ detailData.info.nickname }}</div>
            </div>
          </div>
          <div
            class="coach-image-content"
            v-if="detailData.info.coach_certificate"
          >
            <img class="coach-image" :src="detailData.info.coach_certificate" />
          </div>
          <div
            class="qa-screenshot-content"
            v-if="detailData.info.answering_questions_img.length"
          >
            <img
              class="qa-screenshot-image"
              @click.stop="previewScreenshotImage(item)"
              v-for="(item, index) in detailData.info.answering_questions_img"
              :key="index"
              :src="item"
            />
          </div>
          <div class="user-talk-content">
            <img
              class="dot"
              src="https://cdnvue.gymcity.com.cn/uploads/58e186fb369273119c9e9aa966d63a4c.png"
            />
            <div class="text">
              通过不断学习，我的饮食结构有了改善和进步，吃得越来越正确，越来越健康，减脂效果也越来越好
            </div>
            <div class="userinfo">
              <div class="line"></div>
              <img class="avatar" :src="detailData.info.user_head" />
              <div class="username">{{ detailData.info.nickname }}</div>
            </div>
          </div>
          <!-- 好的餐卡和差的餐卡 -->
          <div class="good-bad-content" v-if="detailData.info.dietData.length">
            <!-- 营养师点评 -->
            <div
              class="score-item"
              v-for="(item, index) in detailData.info.dietData"
              :key="index"
            >
              <span class="say-text" v-if="item.say">{{ item.say }}</span>
              <div
                class="score-image-content"
                :class="{ 'score-image-lists': item.content.length }"
              >
                <img
                  class="score-image-item"
                  v-for="(item1, index1) in item.content"
                  :key="index1"
                  @click.stop="previewReviewsImage(item.content, item1)"
                  :src="item1"
                />
              </div>
              <div class="score-content">
                <div class="score-class">{{ item.p_star }}星</div>
                <div class="star-content">
                  <div
                    class="star-item iconfont icon-xingxingbeifen9"
                    :class="{ 'star-item-active': index1 < item.p_star }"
                    v-for="(item1, index1) in 5"
                    :key="index1"
                  ></div>
                </div>
              </div>
              <div class="review">
                <div class="review-bottom">
                  <div class="coach-info">
                    <img class="avatar" :src="item.p_img" />
                    <span class="coach-name">{{ item.p_name || '' }}</span>
                  </div>
                  <div class="info">
                    <span>{{ item.p_content || '' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 餐卡图片列表 -->
          <div class="diet-image-list" v-if="detailData.info.group_img.length">
            <img
              class="diet-image-item"
              @click.stop="previewRandomDietImage(item)"
              v-for="(item, index) in detailData.info.group_img"
              :key="index"
              :src="item"
            />
          </div>
        </div>
        <!-- 学员感言 -->
        <div
          class="talk-content"
          v-if="detailData.info.my_story && detailData.info.my_story.length"
        >
          <div class="title-content">
            <span class="title-line"></span>
            <span class="title-text">我的故事</span>
            <span class="title-line"></span>
          </div>
          <div class="talk-list">
            <div
              class="talk-item"
              v-for="(item, index) in detailData.info.my_story"
              :key="index"
              v-show="item.answer || item.img.length"
            >
              <div class="problem">
                <span class="problem-text">{{ item.title }}</span>
              </div>
              <div class="answer">
                <div class="answer-content">
                  <div class="answer-text">
                    <div class="say-content">
                      <span>{{ item.answer }}</span>
                    </div>
                    <img
                      v-for="(imageitem, imageindex) in item.img"
                      :key="imageindex"
                      @click.stop="previewChatImage(item.img, imageitem.url)"
                      :src="imageitem.url"
                    />
                  </div>
                </div>
                <img class="avatar" :src="detailData.info.user_head" />
              </div>
            </div>
          </div>
          <div class="user-talk-content" v-if="detailData.info.copy">
            <img
              class="dot"
              src="https://cdnvue.gymcity.com.cn/uploads/58e186fb369273119c9e9aa966d63a4c.png"
            />
            <div class="text">{{ detailData.info.copy || '' }}</div>
            <div class="userinfo">
              <div class="line"></div>
              <img class="avatar" :src="detailData.info.user_head" />
              <div class="username">{{ detailData.info.nickname }}</div>
            </div>
          </div>
        </div>
        <div class="footer-content">
          <div>
            <div class="desc1">私信小助理，加入明星减脂营</div>
            <div class="desc2">开启你的最后一次减肥</div>
          </div>
          <img
            class="qrcode"
            src="https://cdnvue.gymcity.com.cn/uploads/c11dc5b0381a74f6560cab524f395f02.jpg"
          />
        </div>
        <div class="comment-list">
          <!-- <wegymer-comment info="{{detailData}}" data="{{commentData}}" bindtoUser="bindToUser"
          bindshowmore="bindShowmore" binddelete="bindDeleteComment" bindcancel="bindCancel" bindlike="bindLikeComment"></wegymer-comment>
        <v-loading class="v-loading" wx:if="{{loadingComment}}" /> -->
          <CommentContent
            :info="detailData"
            :data="commentData"
            @toUser="bindToUser"
            @showmore="bindShowmore"
            @delete="bindDeleteComment"
            @cancel="bindCancel"
          />
          <div
            class="not-more"
            v-if="!loadingComment && finished && commentData.length"
          >
            没有更多评论了
          </div>
        </div>
        <div>
          <ChatContent
            ref="chatcontent"
            :articleInfo="detailData"
            :chatInfo="chatInfo"
            @resetUser="resetCommentInfo"
            @collect="bindCollectDynamic"
            @comment="bindComment"
            @like="bindlikeDynamic"
          />
          <!-- <wegymer-chat id="chatcontent" articleInfo="{{detailData}}" chatInfo="{{chatInfo}}"
          bindresetUser="resetCommentInfo" bindcollect="bindCollectDynamic" bindcomment="bindComment"
          bindlike="bindlikeDynamic"></wegymer-chat> -->
        </div>
      </div>
    </div>
    <!--  <v-loading class="v-loading" v-else /> -->
  </div>
</template>
<script>
import ChatContent from '@/views/business-center/components/chat-content/index'
import CommentContent from '@/views/business-center/components/comment-content/index'
import { ImagePreview } from 'vant'
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core'
// 引入柱状图图表，图表后缀都为 Chart
import { LineChart } from 'echarts/charts'
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DataZoomComponent
} from 'echarts/components'
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features'
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers'

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  DataZoomComponent,
  LineChart
])
export default {
  components: {
    ChatContent,
    CommentContent
  },
  data() {
    return {
      defaultAvatar: [
        'https://cdnvue.gymcity.com.cn/uploads/b2ae63e6c8ce86d5ad1cbd0ab233ce83.png',
        'https://cdnvue.gymcity.com.cn/uploads/1ce985d5712871e05b0d65e638924a29.png',
        'https://cdnvue.gymcity.com.cn/uploads/b2ae63e6c8ce86d5ad1cbd0ab233ce83.png'
      ],
      curSwiper: 0,
      curSwiper1: 0,
      imageHeight: 0,
      typeId: '',
      canvasData: [],
      score: {
        val: 3.5,
        star: 5,
        percent: 100
      },
      dataOrigen: [], //获取的总数据
      curListX: [],
      curListY: [],
      curNav: 0,
      curKey: null, // 当前key
      curValue: null,
      curUnit: null, // 当前单位
      lastTime: null, // 上次时间
      changeY: null, // 改变的值
      ecLine: {
        /* canvas图表数据 */
        lazyLoad: true
      },
      swiperData: [],
      typeList: ['体重', '腰围'],
      curType: 0,
      detailData: null,
      questionList: [
        '',
        '我是谁？',
        '为什么要减肥？肥胖给我带来什么困扰？',
        '我尝试过哪些失败的减肥方法？',
        '结营感言'
      ],
      curShareType: 0,
      curCampShare: 0,
      moreCaseData: [],
      /*  */
      isSubmitComment: false, // 是否正在提交评论
      commentData: [],
      recommendData: [],
      loading: false,
      finished: false,
      loadingComment: false, //是否正在加载评论
      data: null,
      isCollect: false,
      title: '详情',
      id: '',
      curPage: 1,
      imageList: [],
      chatInfo: {}, //当前正在聊天人的信息
      chatParentInfo: {}, //当前正在聊天人的父级信息
      parentIndex: '', // 当前点击的评论的父级index
      index: '', // 当前点击的评论处于父级第index + 1个
      readyNum: 0, //canvas数据和dom准备的数量 必须都拿到才能渲染canvas
      isShareing: false, //是否正在分享中
      echartsDoms: []
    }
  },
  filters: {
    formatDynamicNumber(num) {
      if (!num && num !== 0) {
        return ''
      }
      var res = ''
      num = isNaN(parseInt(num)) ? '-' : parseInt(num)
      if (num === '-') {
        return '-'
      }
      if (num >= 100000) {
        res = '10w+'
      } else if (num >= 10000) {
        res = (num / 10000).toFixed(1) + 'w'
      } else if (num >= 1000) {
        res = (num / 1000).toFixed(1) + 'k'
      } else {
        res = num
      }
      return res
    }
  },
  created() {
    this.getParams(this.$route.query)
  },
  mounted() {
    this.loadData()
    this.readyCanvasData()
  },
  methods: {
    getParams(options) {
      this.id = (options && options.id) || ''
      this.typeId = (options && options.typeId) || ''
    },
    //点赞评论
    bindLikeComment(e) {
      console.log(e)
      let index = e.detail.index
      let index1 = e.detail.index1
      let id = ''
      let opt = 1
      if (index1 === '') {
        //点赞的是最外层的评论
        id = this.data.commentData[index].id
        opt = this.data.commentData[index].is_love ? 0 : 1
      } else {
        id = this.data.commentData[index].comment_list[index1].id
        opt = this.data.commentData[index].comment_list[index1].is_love ? 0 : 1
      }
      let params = {
        comment_id: id,
        opt
      }
      http
        .request({
          url: 'member/StorageLogin/setCaseCommentLove',
          data: params,
          method: 'POST'
        })
        .then((res) => {
          if (res.code == 200) {
            let paramsData = ''
            let res = {}
            if (index1 === '') {
              paramsData = 'commentData[' + index + ']'
              res = this.data.commentData[index]
            } else {
              paramsData =
                'commentData[' + index + '].comment_list[' + index1 + ']'
              res = this.data.commentData[index].comment_list[index1]
            }
            res.is_love = opt
            res.zan_num = opt
              ? ++res.zan_num
              : --res.zan_num < 0
              ? 0
              : res.zan_num
            this.setData({
              [paramsData]: res
            })
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    //预览点评的餐卡图片
    previewReviewsImage(urls, current) {
      let index = urls.indexOf(current)
      ImagePreview({
        images: urls,
        startPosition: index
      })
    },
    //预览聊天对话框中的图片
    previewChatImage(urlsArr, current) {
      let urls = []
      urlsArr.map((item) => {
        if (item.url) {
          urls.push(item.url)
        }
      })
      let index = urls.indexOf(current)
      ImagePreview({
        images: urls,
        startPosition: index
      })
    },
    //预览生活照
    previewLiveImage(curUrl) {
      let urls = []
      let info = this.detailData.info
      //获取较长的那个对比生活照片数组
      let longArr =
        info.start_life_img.length > info.end_life_img.length
          ? info.start_life_img
          : info.end_life_img
      longArr.map((item, index) => {
        if (info.start_life_img[index]) {
          urls.push(info.start_life_img[index])
        }
        if (info.end_life_img[index]) {
          urls.push(info.end_life_img[index])
        }
      })
      let index = urls.indexOf(curUrl)
      ImagePreview({
        images: urls,
        startPosition: index
      })
    },
    //预览对比照
    previewCompareImage(curUrl) {
      let urls = []
      let info = this.detailData.info
      //获取较长的那个对比照数组
      let longArr =
        info.start_img.length > info.end_img.length
          ? info.start_img
          : info.end_img
      longArr.map((item, index) => {
        if (info.start_img[index]) {
          urls.push(info.start_img[index])
        }
        if (info.end_life_img[index]) {
          urls.push(info.end_img[index])
        }
      })
      let index = urls.indexOf(curUrl)
      ImagePreview({
        images: urls,
        startPosition: index
      })
    },
    //预览答疑截图
    previewScreenshotImage(current) {
      let urls = this.detailData.info.answering_questions_img
      let index = urls.indexOf(current)
      ImagePreview({
        images: urls,
        startPosition: index
      })
    },
    //预览随机餐卡截图
    previewRandomDietImage(current) {
      let urls = this.detailData.info.group_img
      let index = urls.indexOf(current)
      ImagePreview({
        images: urls,
        startPosition: index
      })
    },
    setTypeInc() {
      let params = {
        tid: this.detailData.id
      }
      this.$http
        .postApp('member/StorageLogin/setTypeInc', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.detailData.num = parseInt(this.detailData.num) + 1
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    bindPictureChange(index) {
      this.curSwiper = index
    },
    bindPicture1Change(index) {
      this.curSwiper1 = index
    },
    //弹出回复或者删除弹框并点击取消时
    bindCancel() {
      this.resetCommentInfo()
    },
    //删除自己的评论
    bindDeleteComment(chatParentInfo, chatInfo, parentIndex, index) {
      this.chatInfo = chatInfo
      this.chatParentInfo = chatParentInfo
      this.parentIndex = parentIndex
      this.index = index
      let params = {
        id: this.chatInfo.id
      }
      this.resetCommentInfo()
      this.$http
        .postApp('member/StorageLogin/delCaseComment', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.updateComment({
              parentIndex,
              index,
              type: 'less'
            })
            this.$toast('删除成功')
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },

    //重置评论人信息
    resetCommentInfo() {
      this.index = ''
      this.parentIndex = ''
      this.chatParentInfo = {}
      this.chatInfo = {}
    },
    // 点赞这个文章
    bindlikeDynamic() {
      let params = {
        data_id: this.detailData.id,
        opt: this.detailData.is_useful ? 0 : 1
      }
      this.$http
        .postApp('member/StorageLogin/setCaseUseful', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let data = this.detailData
            data.is_useful = data.is_useful ? 0 : 1
            if (data.is_useful) {
              this.detailData.useful = data.useful + 1
              this.$toast('点赞成功')
            } else {
              this.detailData.useful = --data.useful < 0 ? 0 : data.useful
              this.$toast('取消点赞')
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    //收藏
    bindCollectDynamic() {
      let params = {
        tid: this.detailData.id,
        type_0: this.detailData.type_id,
        type: this.detailData.is_save === 0 ? 2 : 1
      }
      this.$http
        .postApp('member/StorageLogin/optSave', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let data = this.detailData
            data.is_save = data.is_save === 0 ? 1 : 0
            if (data.is_save === 0) {
              this.detailData.save_num = data.save_num + 1
              this.$toast('收藏成功')
            } else {
              this.detailData.save_num = --data.save_num < 0 ? 0 : data.save_num
              this.$toast('取消收藏')
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    //评论某个用户
    bindComment(val) {
      if (this.isSubmitComment) {
        return
      }
      this.isSubmitComment = true
      let parentIndex = this.parentIndex
      let index = this.index
      let data_id = this.detailData.info.id
      let comment = val
      let t_uid = (this.chatInfo && this.chatInfo.uid) || 0
      let parent_id = (this.chatParentInfo && this.chatParentInfo.id) || ''
      let params = {
        data_id,
        t_uid,
        parent_id,
        comment
      }
      this.$http
        .postApp('member/StorageLogin/saveCaseComment', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let data = res.data
            data.comment_list = []
            console.log(parentIndex, index)
            this.updateComment({
              parentIndex,
              index,
              type: 'add',
              data: data || {}
            })
            this.resetCommentInfo()
            this.$toast('评论成功')
          } else {
            this.$toast(res.msg)
          }
          this.isSubmitComment = false
        })
        .catch((e) => {
          this.isSubmitComment = false
          console.log(e)
        })
    },
    //更新评论 根据评论的内容是否有父评论决定加在哪里或者删除哪里
    updateComment({ parentIndex, index, type, data }) {
      console.log(parentIndex, index)
      if (type == 'add') {
        if (parentIndex !== '') {
          // 如果是在别人的评论下面评论
          this.commentData[parentIndex].comment_list.unshift(data)
          this.commentData[parentIndex].commentCount++
        } else {
          //如果评论的是顶级的评论则直接在最上面新增评论
          data.commentCount = 0
          this.commentData.unshift(data)
        }
      } else {
        if (parentIndex !== '' && index !== '') {
          //删除顶级评论下面的二级评论
          this.commentData[parentIndex].comment_list.splice(index, 1)
          this.commentData[parentIndex].commentCount =
            --this.commentData[parentIndex].commentCount < 0
              ? 0
              : this.commentData[parentIndex].commentCount
        } else {
          //删除顶级评论
          this.commentData.splice(parentIndex, 1)
          // this.commentData[parentIndex].hide = true;
        }
      }
    },
    bindShowmore(e) {
      let index = e.detail.index
      let params = 'commentData[' + index + '].showMore'
      this.setData({
        [params]: true
      })
    },
    bindToUser(chatParentInfo, chatInfo, parentIndex, index) {
      this.chatInfo = chatInfo
      this.chatParentInfo = chatParentInfo
      this.parentIndex = parentIndex
      this.index = index
      let chateComponent = this.$refs.chatcontent
      chateComponent.bindShowInput()
    },
    jumpUserInfo() {
      let id = this.data.detailData.unify_id
    },
    getheight(e) {
      this.createSelectorQuery()
        .select('.swiper-border')
        .boundingClientRect((rect) => {
          var width = rect.width
          //获取可使用窗口宽度
          var imgheight = e.detail.height
          //获取图片实际高度
          var imgwidth = e.detail.width
          //获取图片实际宽度
          var height = (width * imgheight) / imgwidth
          var curImageHeight = parseInt(this.data.imageHeight)
          height = curImageHeight > height ? curImageHeight : height
          console.log('高度是', height)
          //计算等比swiper高度
          this.setData({
            imageHeight: height
          })
        })
        .exec()
    },
    setOption(chart, xList, yList) {
      var option = {
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            label: {
              show: true,
              backgroundColor: '#6a7985'
            }
          }
        },
        dataZoom: [
          {
            type: 'inside', //图表下方的伸缩条
            show: true,
            realtime: true,
            start: 0,
            end: 100,
            zoomLock: true
          }
        ],
        grid: {
          top: '10%',
          bottom: '20%',
          left: '5%',
          right: '5%'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#000000', //更改坐标轴文字颜色
              fontSize: 10 //更改坐标轴文字大小
            }
          },
          data: xList
        },
        yAxis: {
          show: false,
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          },
          min: function (value) {
            return value.min - ((value.max - value.min) / 0.5) * 0.3
          },
          max: function (value) {
            return value.max + ((value.max - value.min) / 0.5) * 0.2
          }
        },
        series: [
          {
            data: yList,
            type: 'line',
            smooth: true,
            lineStyle: {
              color: 'rgb(240,70,70)' //曲线的颜色
            },
            itemStyle: {
              color: 'rgb(240,70,70)' //点的颜色
            },
            label: {
              normal: {
                show: true,
                position: 'top',
                fontSize: 10
              }
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(240,70,70,0.7)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(240,70,70,0)' // 区域100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
        ]
      }
      chart.setOption(option)
      // chart.on('click', function (params) {
      //   console.log('paramsparams', params, WX)
      //   WX.setData({
      //     showDel: true,
      //     delTop: (params.event.offsetY - 60),
      //     delLeft: (params.event.offsetX - 20)
      //   })
      // });
    },
    changeType(index) {
      this.curType = index
      this.$refs.weightWaist.swipeTo(index)
    },
    changeShareType(e) {
      this.setData({
        curShareType: e.currentTarget.dataset.index
      })
    },
    collect() {
      let isCollect = this.data.detailData.is_save
      let params = {
        tid: this.data.id,
        type_0: this.data.typeId,
        type: isCollect ? 2 : 1
      }
      http
        .request({
          url: 'member/StorageLogin/optSave',
          data: params,
          method: 'POST'
        })
        .then((res) => {
          if (res.code === 200) {
            this.data.detailData.is_save =
              this.data.detailData.is_save === 0 ? 1 : 0
            this.setData({
              detailData: this.data.detailData
            })
            let tips = ''
            if (this.data.detailData.is_save == 1) {
              tips = '收藏成功'
            } else {
              tips = '取消收藏'
            }
            this.$toast(tips)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    /**
     * 获取体重差距
     */
    getDistance() {
      if (this.data.targetWeight != '' && this.data.targetWeight != '-') {
        this.setData({
          distanceWeight: (
            Number(this.data.curWeight) - Number(this.data.targetWeight)
          ).toFixed(1)
        })
      }
    },
    changeSwiper(index) {
      this.curType = index
    },
    /**
     * 加载echarts
     */
    init: function (index) {
      console.log(index)
      // 接下来的使用就跟之前一样，初始化图表，设置配置项
      let div = document.getElementById('mychart-dom-line-' + index)
      console.log(div)
      this.echartsDoms[index] = echarts.init(div)
      this.setOption(
        this.echartsDoms[index],
        this.canvasData[index].xList,
        this.canvasData[index].yList
      )
    },
    loadData() {
      let params = {
        tid: +this.id
      }
      this.$http
        .postApp('member/StorageLogin/getDetail', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            res.data.info = this.dealData(res.data.info)
            let canvasData = this.dealCanvasData(res.data.info.change)
            this.detailData = res.data
            this.canvasData = canvasData
            this.setTypeInc()
            this.$nextTick(() => {
              this.readyCanvasData()
            })
            this.getComment()
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    readyCanvasData() {
      this.readyNum++
      if (this.readyNum >= 2) {
        // 获取组件
        for (let i = 0; i < this.typeList.length; i++) {
          this.init(i)
        }
      }
    },
    //给请求的数据加上一些属性
    dealCommentData(data) {
      data.map((item) => {
        item.showMore = false
        item.hide = false
        item.commentCount = item.comment_list.length
        item.comment_list &&
          item.comment_list.map((item1) => {
            item1.hide = false
          })
      })
      return data
    },
    getComment() {
      let params = {
        data_id: this.detailData.info.id,
        page: this.curPage
      }
      this.loadingComment = true
      this.$http
        .getApp('member/StorageLogin/getCaseComment', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (res.data.data && res.data.data.length) {
              let arr = this.dealCommentData(res.data.data)
              this.commentData = this.commentData.concat(arr)
              this.comments_count = res.data.total || 0
              this.curPage++
            } else {
              this.finished = true
            }
          } else {
            this.$toast(res.msg)
          }
          this.loading = false
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.loadingComment = false
        })
    },

    dealCanvasData(data) {
      let arr = []
      arr.push({
        changeData: parseFloat(
          (data.end_weight - data.first_weight).toFixed(2)
        ),
        startData: data.first_weight,
        curData: data.end_weight,
        xList: data.weight_list.map((item) => {
          let time = item.key.split(' ')[0]
          return time.slice(5).replace('-', '/')
        }),
        yList: data.weight_list.map((item) => {
          return +item.val
        }),
        name: '体重',
        unit: 'kg'
      })
      arr.push({
        changeData: parseFloat((data.end_waist - data.first_waist).toFixed(2)),
        startData: data.first_waist,
        curData: data.end_waist,
        xList: data.waist_list.map((item) => {
          let time = item.key.split(' ')[0]
          return time.slice(5) + '\n' + time.split('-')[0]
        }),
        yList: data.waist_list.map((item) => {
          return +item.val
        }),
        name: '腰围',
        unit: 'cm'
      })
      return arr
    },
    //处理数据
    dealData(data) {
      //处理对比照，如果入营和结营的第几张图片都没有则删除这个位置的空字符串
      let end_img = []
      let start_img = []
      for (var i in data.start_img) {
        start_img.push(data.start_img[i])
      }
      for (var i in data.end_img) {
        end_img.push(data.end_img[i])
      }
      let longArr = start_img.length > end_img.length ? start_img : end_img
      for (let i = 0; i < longArr.length; i++) {
        if (!start_img[i] && !end_img[i]) {
          start_img.splice(i, 1)
          end_img.splice(i, 1)
          i--
        }
      }
      data.start_img = start_img
      data.end_img = end_img
      data.dietData = []
      if (
        data.dietary_changes_low_data &&
        !Array.isArray(data.dietary_changes_low_data)
      ) {
        data.dietData.push(data.dietary_changes_low_data)
      }
      if (
        data.dietary_changes_high_data &&
        !Array.isArray(data.dietary_changes_high_data)
      ) {
        data.dietData.push(data.dietary_changes_high_data)
      }
      return data
    },
    /**
     * 生命周期函数--监听页面显示
     */
    onShow: function () {
      this.setData({
        isShareing: false
      })
    }
  }
}
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.detail-page {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: #f7f7f7;
}

.detail-content {
  box-sizing: border-box;
  padding-bottom: 70px;
}

.top {
  background-color: #fff;
  padding: 16px 20px 22px;
  margin-bottom: 10px;
}

.article-info {
  padding-bottom: 15px;
  border-bottom: 1px solid #f1f1f1;
}

.article-info .title {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 30px;
  margin-bottom: 10px;
}

.article-info .review {
  margin-bottom: 7px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.5);
  line-height: 17px;
  display: flex;
  align-items: center;
}

.info-bottom {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.5);
  line-height: 20px;
}

.info-bottom .keyword-title {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.5);
  line-height: 17px;
}

.info-bottom .keyword {
  font-weight: 600;
  color: #2882e9;
  margin-right: 9px;
}

.article-info .review .line {
  margin: 0px 15px;
  height: 10px;
  border-right: 1px solid #979797;
}

.info-bottom .public-image {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.info-bottom .line {
  margin: 0px 15px;
  height: 10px;
  border-right: 1px solid #979797;
}

.info-bottom .public-image:last-child {
  margin-right: 0px;
}

.top .user-info {
  padding-top: 15px;
  display: flex;
}

.top .avatar {
  flex: 0 0 36px;
  margin-right: 10px;
  width: 36px;
  height: 36px;
  background-color: #d8d8d8;
  border-radius: 4px;
  object-fit: cover;
}

.top .user-name {
  font-size: 12px;
  color: #000000;
  font-weight: 600;
  margin-bottom: 2px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-right: 10px;
}

.top .camp {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.top .tag-list {
  font-size: 10px;
  margin-left: 6px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
  flex-wrap: wrap;
}

.top .tag-item {
  text-align: center;
  color: #000;
  font-size: 10px;
  height: 22px;
  padding: 0px 10px;
  box-sizing: border-box;
  white-space: nowrap;
  line-height: 22px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #f1f1f1;
  margin-right: 6px;
  margin-bottom: 6px;
}

.user-info-right {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
}

.top .tag-list .tag-item:last-child {
  margin-right: 0px;
}
.compare-canvas {
  background-color: #fff;
  padding: 14px 16px;
  box-sizing: border-box;
}
.compare-title {
  padding: 0px 20px;
}
.title-content {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 17px;
}
.title-content .title-text {
  margin: 0px 23px;
  font-size: 24px;
  font-family: FZZCHJW--GB1-0, FZZCHJW--GB1;
  color: #000;
  line-height: 29px;
}
.title-content .title-line {
  flex: 1;
  height: 1px;
  background-color: #e7e7e7;
}
.type-list {
  margin: 0 auto;
  width: 86px;
  display: flex;
  align-items: center;
  height: 20px;
  background-color: #f1f1f1;
  border-radius: 4px;
  font-size: 10px;
  margin-bottom: 16px;
}

.type-list .iconfont {
  margin-left: 5px;
}

.type-list .type-item {
  width: 43px;
  text-align: center;
  line-height: 20px;
  box-sizing: border-box;
  color: #000;
}
.type-list .type-item-active {
  width: 45px;
  height: 24px;
  line-height: 24px;
  background-color: #ffffff;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  border: 1px solid #dddddd;
}

.echart-content {
  margin-bottom: 16px;
}

.echart-canvas {
  height: 260px;
}

.echart-canvas .no-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.compare-container {
  background-color: #fff;
  margin-bottom: 21px;
  padding: 16px;
  padding-bottom: 0px;
  box-sizing: border-box;
  overflow: hidden;
}
.compare-container .title {
  height: 29px;
  line-height: 29px;
  background: #f7f7f7;
  border-radius: 4px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #000;
  margin-bottom: 14px;
  overflow: hidden;
}
.compare-swiper-content {
  width: 100%;
  height: 258px;
}
.compare-swiper {
  width: 100%;
  height: 100%;
}
.image-content {
  box-sizing: border-box;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.image-content .line {
  border: 1px solid #e7e7e7;
  width: 0;
  height: 100%;
}
.image-item {
  width: 169px;
  height: 100%;
  box-sizing: border-box;
  background: #fff;
  border-radius: 1px;
  border: 1px solid #e7e7e7;
  padding: 10px 10px 12px;
  overflow: hidden;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
}
.image-text {
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000;
  line-height: 17px;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}
.footer-content {
  background-color: #fff;
  box-sizing: border-box;
  width: 100%;
  padding: 17px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #f1f1f1;
  margin-bottom: 10px;
}
.footer-content .desc1 {
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  line-height: 26px;
}
.footer-content .desc2 {
  font-size: 20px;
  font-family: FZZCHJW--GB1-0, FZZCHJW--GB1;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.7);
  line-height: 26px;
}
.qrcode {
  width: 72px;
  height: 72px;
}
.comment-list {
  background-color: #fff;
  padding: 10px 20px;
}
/*  */
.compare-content {
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: space-between;
  height: 250px;
  background-color: #f4f4f4;
  border-radius: 5px;
}
.talk-content {
  background-color: #fff;
  padding: 28px 14px 28px 30px;
}

.talk-list {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.talk-list .talk-item {
  box-sizing: border-box;
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 10px;
}

.talk-list .problem {
  max-width: 288px;
  margin-bottom: 16px;
  position: relative;
}
.talk-list .problem .problem-text {
  display: inline-block;
  text-align: left;
  padding: 6px 22px;
  box-sizing: border-box;
  background: #707a90;
  border-radius: 8px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #fff;
  line-height: 22px;
}
.talk-list .quetion-icon,
.talk-list .answer-icon {
  position: absolute;
  left: 12px;
  top: 6px;
  text-align: center;
  line-height: 18px;
  font-weight: normal;
  font-size: 12px;
  color: #ffffff;
  width: 18px;
  height: 18px;
  background-color: #838aae;
  border-radius: 6px;
}

.talk-list .answer-icon {
  background-color: #cccccc;
}

.talk-list .answer {
  display: flex;
  justify-content: flex-end;
}
.talk-list .answer .answer-content {
  padding-right: 10px;
  text-align: right;
  flex: 1;
  overflow: hidden;
  flex-shrink: 0;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.7);
  line-height: 24px;
}
.talk-list .answer-text {
  max-width: 100%;
  box-sizing: border-box;
  position: relative;
  padding: 8px 15px;
  display: inline-block;
  background: #f7f7f7;
  border-radius: 8px;
  border: 1px solid #f1f1f1;
}
.answer-text .say-content {
  display: inline-block;
  text-align: left;
}
.answer-text text {
  text-align: left;
  word-wrap: break-word;
  word-break: break-all;
}
.answer-text img {
  max-width: 100%;
  min-width: 165px;
}
.talk-list .answer .answer-text::after {
  content: '';
  position: absolute;
  right: -9px;
  top: 10px;
  z-index: 1;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-left: 10px solid #f7f7f7;
  border-bottom: 7px solid transparent;
}
.talk-list .answer .avatar {
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  margin-left: 15px;
  border-radius: 4px;
  object-fit: cover;
}
.echart-swiper {
  width: 100%;
  height: 100%;
}

.share {
  margin-bottom: 10px;
  background-color: #fff;
  padding: 16px;
}

.share-card-item .user-info {
  margin-bottom: 13px;
  display: flex;
  align-items: center;
}

.share-card-item .avatar {
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  background-color: #d8d8d8;
  border-radius: 4px;
  object-fit: cover;
}

.share-card-item .zan-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.share-card-content .tag-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.share-card-content .tag-item {
  height: 22px;
  flex-shrink: 0;
  margin-right: 6px;
  margin-bottom: 6px;
  white-space: nowrap;
  padding: 4px 15px;
  box-sizing: border-box;
  color: #63a477;
  font-size: 10px;
  background-color: rgba(53, 199, 99, 0.1);
  border-radius: 4px;
}

.share-card-item .user-name {
  flex: 1;
  margin: 0px 10px;
  flex-shrink: 0;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.share-card-item .time {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);
}

.share-card-item .zan-num {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.5);
}

.share-card-item .info {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  margin-bottom: 11px;
}

.share-card-item .image-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 13px;
}

.share-card-item .image-item {
  position: relative;
  flex-shrink: 0;
  width: 150px;
  height: 150px;
  margin-right: 8px;
  border-radius: 4px;
  margin-bottom: 8px;
  overflow: hidden;
}
.compare-image-content {
  width: 100%;
  height: 210px;
  margin-bottom: 7px;
}
.compare-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.compare-empty {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  background-color: #f2f2f2;
}
.detail-page .share-card-item .image-item-one {
  position: relative;
  flex-shrink: 0;
  width: 309px !important;
  height: 309px !important;
  border-radius: 4px;
  margin-bottom: 8px;
  overflow: hidden;
}

.image-item-one .image {
  width: 100%;
  height: 100%;
}

.share-card-item .image-item:nth-child(2n) {
  margin-right: 0px;
}

.share-card-item .image-count {
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px;
  border-radius: 2px;
  color: #fff;
  font-size: 12px;
}

.share-card-item .tag-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
}

.share-card-item .tag-item {
  padding: 3px 9px;
  font-size: 12px;
  color: #49ceba;
  background-color: rgb(237, 251, 248);
  border-radius: 4px;
  margin-right: 5px;
}

.share-card-item .score-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 9px;
}

.score-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.score-class {
  font-size: 10px;
  line-height: 20px;
  color: #000000;
}

.share-card-item .score-item {
  position: relative;
  margin-right: 5px;
  width: 15px;
  height: 15px;
}

.share-card-item .score-content .mask {
  width: 15px;
  height: 15px;
  position: absolute;
  z-index: 1;
  background-color: #fff;
  left: 0;
  top: 0;
}

.share-card-item .score-content .score-img {
  width: 15px;
  height: 15px;
}

.share-card-item .score-content .iconfont {
  font-size: 15px;
  color: rgb(247, 181, 0);
}

.review {
}

.coach-flag {
  display: inline-block;
  padding: 0px 7px;
  height: 14px;
  background-image: linear-gradient(180deg, #ff4e4e 0%, #ff2c55 100%);
  border-radius: 3px;
  font-size: 9px;
  color: #fff;
}

.review .title1 {
  width: 100px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
  background-image: linear-gradient(
    157deg,
    #ffce74 0%,
    #fda343 94%,
    #fda040 100%
  );
  border-radius: 6px 6px 0px 0px;
}

.score-padding {
  position: relative;
  background-color: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  border: 1px solid #f1f1f1;
  padding: 16px;
  overflow: hidden;
  box-sizing: border-box;
}

.score-padding .diet-flag {
  width: 0;
  height: 0;
  border-bottom: 45px solid #d89374;
  border-left: 45px solid transparent;
  border-right: 45px solid transparent;
  position: absolute;
  left: -17px;
  top: -17px;
  transform: rotate(-45deg);
  transform-origin: 50% 100%;
  z-index: 7;
}

.diet-flag .flag-text {
  white-space: nowrap;
  font-size: 12px;
  position: absolute;
  left: 50%;
  bottom: -40px;
  transform: translate(-50%);
  color: #fff;
}

.review .review-bottom {
  padding: 9px 0px;
  border-radius: 0px 5px 5px 5px;
}
.review-bottom .coach-info {
  display: flex;
  align-items: center;
}
.review .avatar {
  flex: 0 0 22px;
  margin-right: 6px;
  width: 22px;
  height: 22px;
  border-radius: 5px;
  object-fit: cover;
}

.review .user-info {
  display: flex;
  align-items: center;
}

.review .coach-name {
  font-size: 10px;
  color: #000000;
  white-space: nowrap;
  margin-right: 5px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.review .info {
  word-break: break-all;
  margin-top: 5px;
  font-size: 10px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.6);
}

.camp-share {
  background-color: #fff;
  margin-bottom: 10px;
  padding: 16px;
  box-sizing: border-box;
}

.camp-share-title {
}

.camp-share-swiper {
  margin: 0 auto;
  width: 100%;
  height: 500px;
}

.camp-share-swiper .camp-share-image {
  background-color: #fff;
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.camp-share-swiper .before {
  transform: scale(0.8) translate(50%);
}

.camp-share-swiper .after {
  transform: scale(0.8) translate(-50%);
}

.swiper-dots {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
}

.swiper-dots-item {
  flex: 1;
  width: 0;
  max-width: 7px;
  height: 3px;
  margin-right: 5px;
  background-color: #cccccc;
  border-radius: 1px;
}

.swiper-dots-item-active {
  flex: 2;
  max-width: 17px;
  background-color: #000000;
}

.more-case {
  padding: 12px 20px;
  background-color: #fff;
}

.more-case .more-case-list {
  display: flex;
  width: 100%;
  overflow-x: scroll;
  align-items: center;
  justify-content: space-between;
}

.more-case .more-case-item {
  flex-shrink: 0;
  width: 48%;
  margin-right: 1%;
  box-sizing: border-box;
  background-color: #f7f7f7;
  border-radius: 6px;
  padding: 9px 10px;
}

.more-case-item .tag-list {
  font-size: 10px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 6px;
  align-items: center;
}

.more-case-item .top {
  background-color: transparent;
  padding: 0px;
}

.more-case-item .tag-item {
  text-align: center;
  color: #000;
  white-space: nowrap;
  background-color: #ffffff;
  border-radius: 4px;
  height: 15px;
  max-width: 80px;
  min-width: 50px;
  line-height: 15px;
  margin-right: 3px;
}

.more-case-item .tag-list .tag-item:last-child {
  margin-right: 0px;
}

.more-case .top {
  margin-bottom: 8px;
}

.more-case .avatar {
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  object-fit: cover;
}

.more-case .flex-1 {
  flex: 1;
  width: 0;
}

.more-case .image-list {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  border-radius: 6px;
  overflow: hidden;
  justify-content: space-between;
  position: relative;
}

.image-list .icon-chengyuan {
  font-size: 10px;
  margin-right: 5px;
}

.image-list .read-num {
  position: absolute;
  border-radius: 1px;
  padding: 2px 5px;
  right: 0;
  bottom: 0;
  font-size: 9px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
}

.more-case .image-item {
  width: 50%;
  height: 100px;
}

.more-case .info {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 10px;
  line-height: 15px;
  color: #000000;
}

.icon-xinxing {
  color: rgb(197, 197, 197);
  font-size: 15px;
}

.like-active {
  color: rgb(240, 70, 70);
}

.v-loading {
  display: flex;
  align-items: center;
  justify-content: center;
}

.mychart-content {
  height: 175px;
}
.mychart-content .my-chart {
  width: 100%;
  height: 100%;
}
.compare-weight {
  display: flex;
  align-items: center;
  justify-content: center;
}

.compare-weight .change {
  margin-right: 40px;
}

.compare-weight .weight-change {
  font-size: 48px;
  color: #000;
}

.compare-weight .weight-unit {
  font-size: 12px;
  color: #000;
}

.compare-weight .weight-text {
  font-size: 12px;
  color: #000000;
  margin-right: 5px;
}

.compare-weight .weight-num {
  font-size: 14px;
  color: #000;
  font-weight: 600;
}

.swiper-border {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 50px 10px 10px;
  background-color: #f7f7f7;
  border: 1px solid#f1f1f1;
}

.swiper-border-active {
  opacity: 0.2;
}

.swiper-camp-name {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  position: absolute;
  left: 50%;
  top: 12px;
  transform: translate(-50%, 0%);
  text-align: center;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  color: #000000;
}

.score-item .iconfont {
  font-size: 19px;
}

.collect .collect-btn {
  margin-left: 9.3vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.collect .collect-btn .iconfont {
  font-size: 6.4vw;
  color: #ccc;
}

.collect .collect-btn .active {
  color: #f7b500;
}

.collect .collect-btn .text {
  margin-top: 2vw;
  line-height: 4.5vw;
  font-family: PingFangSC-Regular;
  font-size: 3.2vw;
  color: #000000;
}
.swiper-indicator {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 13px;
  margin-bottom: 20px;
}
.swiper-indicator .swiper-indicator-item {
  width: 6px;
  height: 6px;
  background: #ccc;
  border-radius: 3px;
  margin-right: 6px;
}
.swiper-indicator .swiper-indicator-item-active {
  width: 10px;
  height: 10px;
  background: #9ba7b8;
  border-radius: 5px;
}
.camp-study {
  padding: 31px 33px;
  background-color: #fff;
}
.user-talk-content {
  position: relative;
  margin-top: 42px;
  margin-bottom: 5px;
  z-index: 0;
}
.user-talk-content .dot {
  position: absolute;
  width: 64px;
  height: 60px;
  left: 0;
  top: -40px;
  z-index: -1;
}
.user-talk-content .text {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #000;
  line-height: 26px;
  margin-bottom: 4px;
}
.user-talk-content .userinfo {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.user-talk-content .line {
  width: 50px;
  height: 1px;
  background-color: #696969;
}
.user-talk-content .avatar {
  width: 32px;
  height: 32px;
  border-radius: 5px;
  overflow: hidden;
  margin-left: 17px;
  margin-right: 11px;
  object-fit: cover;
}
.user-talk-content .username {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 20px;
}
.coach-image-content {
  width: 100%;
  margin-bottom: 25px;
}
.coach-image-content .coach-image {
  width: 100%;
}
.good-bad-content {
  margin-top: 35px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 30px;
}
.good-bad-content .score-item {
  width: 150px;
  height: 290px;
  padding: 10px 5px;
  box-sizing: border-box;
  overflow-y: scroll;
  margin-right: 9px;
  background: #ffffff;
  border-radius: 15px;
  border: 3px solid #f1f1f1;
}
.good-bad-content .say-text {
  display: inline-block;
  width: 100%;
  color: #333;
  line-height: 11px;
  word-break: break-all;
  font-size: 10px;
  margin-bottom: 5px;
}
.star-content .star-item {
  margin-right: 5px;
  font-size: 10px;
  color: #ccc;
}

.star-content .star-item-active {
  color: rgb(247, 181, 0);
}
.good-bad-content .score-item:last-child {
  margin-right: 0px;
}
.qa-screenshot-content {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: 62px;
}
.qa-screenshot-content .qa-screenshot-image {
  width: 48%;
  border-radius: 4px;
  margin-right: 4%;
  margin-bottom: 10px;
}
.qa-screenshot-content .qa-screenshot-image:nth-child(2n) {
  margin-right: 0;
}
.qa-screenshot-content .qa-screenshot-image:last-child {
  margin-bottom: 0;
}
.qa-screenshot-content .qa-screenshot-image:nth-last-child(2) {
  margin-bottom: 0;
}
.diet-image-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.diet-image-list .diet-image-item {
  width: 72px;
  height: 72px;
  border-radius: 2px;
  margin-right: 7px;
  margin-bottom: 7px;
  object-fit: cover;
}
.diet-image-list .diet-image-item:nth-child(4n) {
  margin-right: 0px;
}
.content-item {
  margin-bottom: 10px;
}
/*  */
.score-container {
  margin-top: 20px;
}

.score-container .tag-item {
  padding: 3px 9px;
  font-size: 12px;
  color: #49ceba;
  background-color: rgb(237, 251, 248);
  border-radius: 4px;
  margin-right: 5px;
  margin-bottom: 5px;
}

.tag-list .tag-type-advantage {
  background-color: rgba(53, 199, 99, 0.1);
  color: #63a477;
}

.tag-list .tag-type-disadvantage {
  background-color: rgba(240, 70, 70, 0.1);
  color: #dd8585;
}

.tag-list .tag-type-features {
  display: none;
  background-color: rgb(233, 202, 230);
  color: #ca41ec;
}

.star-content {
  display: flex;
  align-items: center;
}
.good-bad-content .score-image-content {
  width: 100%;
}
.good-bad-content .score-image-lists {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.score-image-content .score-image-item {
  width: 100%;
  height: 100px;
  border-radius: 2px;
  margin-bottom: 5px;
}
.score-image-lists .score-image-item {
  width: 49%;
  height: 50px;
  margin-right: 2%;
  object-fit: cover;
  margin-bottom: 4px;
}
.score-image-lists .score-image-item:nth-last-child(2n) {
  margin-right: 0px;
}
.not-more {
  font-size: 14px;
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
  margin: 10px 0px;
}
</style>
